import UIkit = require('uikit/dist/js/uikit');
import Icons = require('uikit/dist/js/uikit-icons');
UIkit.use(Icons);
import '@webcomponents/custom-elements';
import 'app.module.scss';
import '../header-nav/header-nav';
